import { environment } from '../../environments/environment';

export class AppConstants {
    public static get tockenURL(): string { return environment.tockenURL; }
    //public static get tockenURL(): string { return 'http://192.168.0.71:8092/'; }
    public static get httpError(): string { return 'There was an HTTP error.'; }
    public static get typeError(): string { return 'There was a Type error.'; }
    public static get generalError(): string { return 'There was a general error.'; }
    public static get somethingHappened(): string { return 'Nobody threw an Error but something happened!'; }
}